import ServiceDetailPage from "../../ones/ServiceDetailPage";
import Footer from "../../ones/Footer";

// Note: Update these paths to your actual mutton-related assets
import muttonImage1 from "../../assets/banner3.jpg"; 
import muttonImage2 from "../../assets/banner5.jpg"; 
import muttonImage3 from "../../assets/banner3.jpg"; 

export default function ServiceMutton() {
  return (
    <>
      <ServiceDetailPage
        label="Premium Export"
        title="Mutton Sourcing & Distribution"
        subtitle="High-grade fresh and frozen mutton processed under strict hygienic standards for the global export market."
        overview="Our mutton distribution network bridges the gap between Tanzanian livestock excellence and international demand. We manage the entire lifecycle—from ethical sourcing and humane processing to temperature-controlled logistics—ensuring every cut retains its premium quality upon arrival."
        images={[
          {
            src: muttonImage1,
            alt: "Premium mutton cuts",
            captionTitle: "Quality-Controlled Processing",
            captionText: "Hygienic butchery and grading according to international specifications.",
          },
          {
            src: muttonImage2,
            alt: "Cold storage facility",
            captionTitle: "Advanced Cold Chain",
            captionText: "State-of-the-art refrigeration to maintain freshness throughout transit.",
          },
          {
            src: muttonImage3,
            alt: "Export packaging",
            captionTitle: "Custom Export Packaging",
            captionText: "Vacuum-sealed and labeled for global retail or wholesale compliance.",
          },
        ]}
        highlights={[
          "Sourced from grass-fed livestock from trusted, disease-free zones.",
          "Certified Halal processing with full traceability and hygiene audits.",
          "Precision-cut options (carcass, prime cuts, or specialty portions).",
          "Seamless end-to-end logistics with real-time temperature monitoring.",
        ]}
        metrics={[
          { value: "100%", label: "Halal Certified & Traceable" },
          { value: "Fresh/Frozen", label: "Dual-mode storage capabilities" },
          { value: "Global", label: "Export-ready logistics network" },
        ]}
      />
      <Footer />
    </>
  );
}